import { render } from "./WomenShoes2.vue?vue&type=template&id=6752c43e"
import script from "./WomenShoes2.vue?vue&type=script&lang=js"
export * from "./WomenShoes2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__